// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"cefbe64b","450":"c9f72d88","787":"49fc1e31","849":"f3d20abc","969":"f3e1ba02"}[chunkId] + ".chunk.js";
};